import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Race } from '../../models/race.model';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Meeting } from '../../models/meeting.model';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PmuService } from '../../services/data/pmu.service';


@Component({
  selector: 'app-info-races',
  imports: [TranslateModule, CommonModule, RouterModule, FormsModule],
  standalone: true,
  templateUrl: './info-races.component.html',
  styleUrl: './info-races.component.scss',
})
export class InfoRacesComponent {
  private _meetings:Meeting[] = [];
  currentIndex = 0;
  private _selectedMeetingId: number = -1;
  races: Race[] = [];
  @Input()
  set meetings(meetings: Meeting[]) {
    this._meetings = meetings;
    this._meetings.forEach(r => {
        r.races.forEach( c => {
            this.races.push(c);
        })
    });
  }
  @Input() selectedRaceId?: number = -1;
  @Output() raceSelected = new EventEmitter<{race: number; meeting: number}>();

  constructor(private pmuService: PmuService) { }

  get meetings() {
    return this._meetings;
  }
  get currentRace() {
    return this.pmuService.getCurrentData()?.race || this.races[this.currentIndex];
  }
  get selectedMeetingId() {
    return this.pmuService.getCurrentData()?.meeting?.id;
  }


  meetingChange(meeting: string){
    let meetingId = parseInt(meeting);
    if(meetingId > -1) {
          this.currentIndex = this.races.findIndex((c) => c.meetingId === meetingId);
          this.selectRace();
    }
  }

  selectRace() {
    const race = this.races[this.currentIndex];
    let output = {
        race: race.id,
        meeting: race.meetingId
    }
    this.raceSelected.emit(output);
  }


  previousRace() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.selectRace();
    }
  }

  nextRace() {
    if (this.currentIndex < this.races.length - 1) {
      this.currentIndex++;
      this.selectRace();
    }
  }
}
